<template>
    <div class='page-start'>
      <mdb-container class="col-10 pb-3" fluid>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1_success" @closeAlert="p1_success=false" dismiss>
				Success! New Product Created!
			</mdb-alert>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p2_success" @closeAlert="p2_success=false" dismiss>
				Success! Changes saved!
			</mdb-alert>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p3_success" @closeAlert="p3_success=false" dismiss>
				Success! Product has been archived!
			</mdb-alert>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p4_success" @closeAlert="p4_success=false" dismiss>
				Success! Product has been re-opened!
			</mdb-alert>

      <!--failure messages-->
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p1_fail" @closeAlert="p1_fail=false" dismiss>
				There was an error submitting the Product. Please try again! Error Code P1_fail
			</mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2_fail" @closeAlert="p2_fail=false" dismiss>
				There was an error archiving the Product. Please try again! Error Code P2_fail
			</mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p3_fail" @closeAlert="p3_fail=false" dismiss>
				There was an error re-opening the Product. Please try again! Error Code P3_fail
			</mdb-alert>

  
      <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Quadrus Corporation Products</h3>
        <mdb-card-body>
         <mdb-col v-if="isCM || isCCB || isAdmin" class="d-flex align-items-center justify-content-center">
            <mdb-btn class="mt-4 QuadrusButton" type="submit" v-on:click="createProject">Create New Product</mdb-btn>
         </mdb-col>
         <br>
          <mdb-col>
            <mdb-input class="mb-0 mt-2" type="checkbox" id="showClosed" name="showClosed" @change="populateProjectData" label="Show previous build lists"/>
            <mdb-input class="mb-0 mt-2" type="checkbox" id="showArchived" name="showArchived" @change="populateProjectData" label="Show archived products"/>
          </mdb-col>
         <QDataTable id='projectTable' :rowData="this.projectData.rowData" :filterWords="this.projectData.filterWords" :headers="this.projectData.columns" 
          :hasBtn="!this.showArchived || (this.showArchived && this.showClosed)" :btnName="'View Project'" @use-method="viewAllWork" 
          :hasEdit="(isCM || isAdmin) && !showClosed" :editName="'Edit Product'" @edit='previewProject' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}"
          >
          </QDataTable>
          <div :class="{'hideSpinner': isSetUp}" class="p-4">
            <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
          </div>
        </mdb-card-body>
      </mdb-card>
  
      <div ref="preview" v-show="previewing">
        <mdb-card  class="mb-3 d-flex">
          <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Product Data</h3>
          <mdb-card-body>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="missingRequired" @closeAlert="missingRequired=false" dismiss>
              {{formErrorMsg}}
            </mdb-alert>

            <form @submit.prevent='' class="was-validated">
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="projectName" label="Product Name" name="productName" :disabled="this.archived" 
                maxlength="60" required invalid-feedback="Please Input Project Name" valid-feedback="Looks Good!"/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="version" label="Version" name="version" :disabled="this.archived" maxlength="60" @change="checkVersion"/>
                <div v-if="!archived && !validVersion" class="invalid-feedback d-block">
                  Please enter a valid version.
                </div>
                <div v-else-if="!archived" class="valid-feedback d-block">
                  Looks Good!
                </div>
              </mdb-col>
              <mdb-col>
                <mdb-select id="pmDropdown" name="pmDropdown" class="mb-3" search v-model="pmOptions" @getValue="setPM" label="Project Manager" :disabled="this.archived"/>
              </mdb-col>
            </mdb-row>
            </form>

            <mdb-row>
              <mdb-col>
                <h5 class="d-flex align-items-left justify-content-left">CCB Members</h5>
                <p class="d-flex align-items-left justify-content-left">{{ ccbMembers.length > 0 ? ccbMembers.map(m => m.attributes.firstName + ' ' + m.attributes.lastName).join(', '): "No members selected" }}</p>
                <mdb-btn v-if="!this.archived" class="mt-4 d-flex align-items-left justify-content-left" color="outline-default" type="submit" 
                  v-on:click="populateCCBOptions">Select CCB Members</mdb-btn>
              </mdb-col>
            </mdb-row>
            <br><br>
                                 

            <mdb-col class="d-flex align-items-center justify-content-center">
                <mdb-btn v-if="!this.archived" class="mt-4 QuadrusButton" type="submit" v-on:click="submitChanges">Submit</mdb-btn>
              </mdb-col>

              <mdb-col class="d-flex align-items-center justify-content-center">
                <mdb-btn v-if="!this.archived && this.projectId" class="mt-4" color="danger" type="submit" v-on:click="viewArchive=true">Archive Product</mdb-btn>
                <mdb-btn v-else-if="this.archived && this.projectId" class="mt-4 QuadrusButton" type="submit" v-on:click="viewUnarchive=true">Re-open Product</mdb-btn>
              </mdb-col>
              

          </mdb-card-body>
        </mdb-card>
      </div>

      <mdb-modal size="xl" centered :show="viewArchive || viewUnarchive" @close="viewArchive = false; viewUnarchive = false" style="z-index: 9999 !important;">
        <mdb-modal-header>
          <mdb-modal-title><p class="h2 grey-text">Archive Product: {{ this.projectName }}</p></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body style="font-size: 0.9em;">
           <mdb-row>
              <mdb-col>
                <p v-if="this.viewArchive">This action will archive the product, {{ this.projectName }}. Are you sure you want to continue?</p>
                <p v-if="this.viewUnarchive">This action will re-open the product, {{ this.projectName }}. Are you sure you want to continue?</p>
              </mdb-col>
            </mdb-row>
        </mdb-modal-body>
        <mdb-modal-footer class="d-flex justify-content-between">
          <mdb-btn color="secondary" @click.native="viewArchive = false, viewUnarchive = false">Cancel</mdb-btn>
          <mdb-btn v-if="this.viewArchive" class="mt-4" color="danger" type="submit" v-on:click="disableProject">Archive Product</mdb-btn>
          <mdb-btn v-if="this.viewUnarchive" class="mt-4 QuadrusButton" type="submit" v-on:click="enableProject">Re-open Product</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>

      <mdb-modal size="xl" centered :show="viewCCBTable" @close="viewCCBTable = false" style="z-index: 9999 !important;">
        <mdb-modal-header>
          <mdb-modal-title><p class="h2 grey-text">CCB Member Assignment</p></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body style="font-size: 0.9em;">
           <mdb-row>
              <mdb-col>
                <h5 class="d-flex align-items-left justify-content-left">CCB Members for {{ this.projectName }}</h5>
                <mdb-input class="mt-0" v-model="search1" label="Search by Name" name="searchBar" />
                <mdb-datatable-2 id="userUnassignTable" ref="userUnassignTable" :key="inCcbKey" v-model="userOptionsInCCB" multiselectable @selected="addedCCBUsers = $event" :searching="{value: search1, field: 'name'}" />
                <mdb-btn :disabled="!addedCCBUsers.length" class="QuadrusButton" @click.native="setCCB">Remove Users from CCB group</mdb-btn>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col>
                <h5 class="d-flex align-items-left justify-content-left">Add CCB users to {{ this.projectName }}</h5>
                <mdb-input class="mt-0" v-model="search2" label="Search by Name" />
                <mdb-datatable-2 id="userAssignTable" ref="userAssignTable" :key="forCcbKey" v-model="userOptionsForCCB" multiselectable @selected="removedCCBUsers = $event" :searching="{value: search2, field: 'name'}" />
                <mdb-btn :disabled="!removedCCBUsers.length" class="QuadrusButton" @click.native="removeCCB">Add Users to CCB group</mdb-btn>
              </mdb-col>
            </mdb-row>
        </mdb-modal-body>

        <mdb-modal-footer class="d-flex justify-content-center">
          <mdb-btn color="secondary" @click.native="viewCCBTable = false">Close</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
  
      </mdb-container>
    </div>
  </template>
  <script>
  import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbBtn, mdbSelect, mdbAlert, mdbDatatable2, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
  import QDataTable from '@/components/QDataTable.vue';
  import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
  import * as sanitizeInput from '@/assets/js/sanitizeInput.js';
  
  export default {
      name: 'IT-Tickets',
      components: {
      mdbInput,
      mdbCard,
      mdbCardBody,
      mdbContainer,
      QDataTable,
      mdbRow,
      mdbCol, 
      mdbBtn,
      mdbSelect,
      mdbAlert,
      mdbDatatable2,
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter
    },
  
    data() {
      return {
        p1_success: false,
        p2_success: false,
        p1_fail: false,
        p2_fail: false,
        p3_success: false,
        p4_success: false,
        p3_fail: false,
        isSetUp: false,
        search1: "",
        search2: "",
        viewCCBTable: false,
        viewArchive: false,
        viewUnarchive: false,
        missingRequired: false,
        formErrorMsg: '',

        //user groups
        isPM: false,
        isCCB: false,
        isCM: false,
        isAdmin: false,
        isDev: false,

        ccbMembers: [],
        addedCCBUsers: [],
        removedCCBUsers: [],
        allCCBUsers: [],
        inCcbKey: 0,
        forCcbKey: 0,

        previewing: false,
        showClosed: false,
        showArchived: false,
  
        projectId: '',
        projectName: '',
        projectManager: '',
        archived: false,
        version: '',
        pmOptions: [],
        addingProject: false,
        validVersion: true,

        oldProjectManager: '',
        oldProjectName: '',

        userOptionsInCCB: {
          columns: [
            {
              label: 'First Name',
              field: 'firstName',
              sort: true
            },
            {
              label: 'Last Name',
              field: 'lastName',
              sort: true
            },
            {
              label: 'Username',
              field: 'username',
              sort: true
            },
            {
              label: 'Email',
              field: 'email',
            }
          ],
          rows: []
        },
        userOptionsForCCB: {
          columns: [
            {
              label: 'First Name',
              field: 'firstName',
              sort: true
            },
            {
              label: 'Last Name',
              field: 'lastName',
              sort: true
            },
            {
              label: 'Username',
              field: 'username',
              sort: true
            },
            {
              label: 'Email',
              field: 'email',
            }
          ],
          rows: []
        },
        
  
        projectData: {
          columns: [  
            {
              colTitle: 'Product Name',
              sortBy: 'ProjectName'
            },
            {
              colTitle: 'Released Version',
              sortBy: 'version'
            },
            {
              colTitle: 'Working Version',
              sortBy: 'workingVersion'
            },
            {
              colTitle: 'Project Manager',
              sortBy: 'ProjectManager'
            },
            {
              colTitle: 'Status',
              sortBy: 'status'
            },
            {
              colTitle: 'Stage',
              sortBy: 'stage'
            },
            {
              colTitle: "Action",
              sortBy: ""
            }
          ],
          rowData: [],
          filterWords: [
            'ProjectName',
            'version',
            'workingVersion',
            'ProjectManager',
            'status',
            'stage'
          ]
        },


  
      }
    },
    methods: {
  
      //===========================================================================================
      //	Method Name	: resetProjectTable
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Resets the project table when changes are made
      //===========================================================================================
      resetProjectTable: function() {
        this.projectData.rowData.splice(0);
      },

      //===========================================================================================
      //	Method Name	:	populateProjectData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Gets project data for the table
      //===========================================================================================
      populateProjectData: async function () {
        this.isSetUp = false;
        this.resetProjectTable();

        const token = this.$store.getters.getToken;
        const currentUser = this.$store.getters.getUser;

        this.showClosed = document.getElementById('showClosed').checked;
        this.showArchived = document.getElementById('showArchived').checked;

        try {
          // -------------------------
          // Query Projects
          // -------------------------
          const query =
            `filters[archived][$eq][0]=${this.showArchived}` +
            `&populate[1]=builds&populate[2]=ccb_users`;
          const response = await DatabaseLib.getRequest(
            'strapiDatabase',
            'projects',
            token,
            query,
            false
          );
          const projects = response.data.data;

          // -------------------------
          // Load Assigned Builds
          // -------------------------
          let assignedBuildIds = new Set();
          if (this.isDev && !this.isAdmin && !this.isCM) {
            const assignedQuery = `filters[username][$eq][0]=${currentUser}`;
            const assignedResponse = await DatabaseLib.getRequest(
              'strapiDatabase',
              'assigned-builds',
              token,
              assignedQuery,
              false
            );
            assignedBuildIds = new Set(
              assignedResponse.data.data.map(b => b.attributes.buildNumber)
            );
          }

          // -------------------------
          // Set Columns
          // -------------------------
          if (this.showArchived && !this.showClosed) {
            this.projectData.columns = [
              { colTitle: 'Product Name', sortBy: 'ProjectName' },
              { colTitle: 'Released Version', sortBy: 'version' },
              { colTitle: 'Project Manager', sortBy: 'ProjectManager' }
            ];
            this.projectData.filterWords = [
              'ProjectName',
              'version',
              'ProjectManager'
            ]
          } else if(this.showClosed){
            this.projectData.columns = [
              { colTitle: 'Product Name', sortBy: 'ProjectName' },
              { colTitle: 'Released Version', sortBy: 'workingVersion' },
              { colTitle: 'Project Manager', sortBy: 'ProjectManager' },
              { colTitle: 'Status', sortBy: 'status' },
              { colTitle: 'Stage', sortBy: 'stage' },
              { colTitle: 'Action', sortBy: '' }
            ];
            this.projectData.filterWords = [
              'ProjectName',
              'workingVersion',
              'ProjectManager',
              'status',
              'stage'
            ]
          } else {
            this.projectData.columns = [
              { colTitle: 'Product Name', sortBy: 'ProjectName' },
              { colTitle: 'Released Version', sortBy: 'version' },
              { colTitle: 'Working Version', sortBy: 'workingVersion' },
              { colTitle: 'Project Manager', sortBy: 'ProjectManager' },
              { colTitle: 'Status', sortBy: 'status' },
              { colTitle: 'Stage', sortBy: 'stage' },
              { colTitle: 'Action', sortBy: '' }
            ];
            this.projectData.filterWords = [
              'ProjectName',
              'version',
              'workingVersion',
              'ProjectManager',
              'status',
              'stage'
            ]
          }
          // -------------------------
          // Process Projects
          // -------------------------
          for (const project of projects) {
            const { id, attributes } = project;
            const {
              ProjectName,
              version,
              ProjectManager,
              archived,
              builds,
              ccb_users
            } = attributes;
            const ccbUsers = ccb_users.data;
            const buildList = builds.data;

            const ccbOnProject =
              ccbUsers.some(u => u.attributes.username === currentUser);

            const pmOnProject =
              this.isPM && ProjectManager === currentUser;

            const hasBaseAccess =
              pmOnProject || ccbOnProject || this.isAdmin || this.isCM;

            // -------------------------
            // OPEN BUILDS MODE
            // -------------------------
            if (!this.showClosed) {
              const currentBuild =
                buildList.find(b => b.attributes.status === "Open");
              const canAccess =
                hasBaseAccess ||
                (this.isDev && currentBuild &&
                assignedBuildIds.has(currentBuild.id));
              if (!canAccess) continue;
              this.projectData.rowData.push({
                id,
                ProjectName,
                version,
                ProjectManager,
                workingVersion: currentBuild ? currentBuild.attributes.version : "",
                status: currentBuild ? currentBuild.attributes.status : "Closed",
                stage: currentBuild ? currentBuild.attributes.stage : "",
                buildId: currentBuild ? currentBuild.id : "",
                archived,
                ccbGroups: ccbUsers
              });
            }

            // -------------------------
            // CLOSED BUILDS MODE
            // -------------------------
            else {
              for (const build of buildList) {
                if (build.attributes.status !== "Closed") continue;
                const canAccess =
                  hasBaseAccess ||
                  (this.isDev && assignedBuildIds.has(build.id));
                if (!canAccess) continue;
                this.projectData.rowData.push({
                  id,
                  ProjectName,
                  version,
                  ProjectManager,
                  status: build.attributes.status,
                  stage: build.attributes.stage,
                  buildId: build.id,
                  archived,
                  ccbGroups: ccbUsers,
                  workingVersion: build ? build.attributes.version : "",
                });
              }
            }
          }
          this.isSetUp = true;
        } catch (error) {
          this.isSetUp = true;
          window.scroll({ top: 0, behavior: 'smooth' });
        }
      },

      resetData: function(){
        this.addingProject = false;
        this.projectId = '';
        this.projectName = '';
        this.version = '';
        this.projectManager = ''; 
        this.previewing = false;
        this.archived = false;
        this.ccbMembers = [];
      },

      disableProject: async function(){
        this.viewArchive = false;
        this.viewUnarchive = false;
        let token = this.$store.getters.getToken;
        let data = {
          data: {
            archived: true
          }
        }

        try {
          // archive the product
          await DatabaseLib.putRequest('strapiDatabase','projects',token,this.projectId,data);

          // archive submitted QPRs
          const payload = {
            projectName: this.projectName,
            data: {archived: true}
          };
          await DatabaseLib.postRequest('strapiDatabase', 'submitted-qpr/bulk-update', token,payload);
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.p3_success = true;
        this.resetData();
        this.populateProjectData();
        window.scroll({top: 0, behavior: 'smooth'});
      },

      enableProject: async function(){
        this.viewUnarchive = false;
        this.viewArchive = false;
        let token = this.$store.getters.getToken;
        let data = {
          data: {
            archived: false
          }
        }

        try {
          await DatabaseLib.putRequest('strapiDatabase','projects',token,this.projectId,data);
         const payload = {
            projectName: this.projectName,
            data: {archived: false}
          };
          await DatabaseLib.postRequest('strapiDatabase', 'submitted-qpr/bulk-update', token,payload);
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p3_fail = true;
          return;
        }
        this.p4_success = true;
        this.resetData();
        this.populateProjectData();
        window.scroll({top: 0, behavior: 'smooth'});
      },

     
      //===========================================================================================
      //	Method Name	:	previewProject
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Loads project data for viewing and editing
      //===========================================================================================
      previewProject: function(data) {
        this.missingRequired = false;
        this.projectId = data.id;
        this.addingProject = false;
        this.projectName = data.ProjectName;
        this.oldProjectName = data.ProjectName;
        this.version = data.version;
        this.projectManager = data.ProjectManager; 
        this.previewing = true;
        this.archived = data.archived;
        this.ccbMembers = data.ccbGroups;
        this.populatePMs();
        this.$nextTick(function() {
          this.$refs.preview.scrollIntoView({behavior: 'smooth'})
        })
      },

      checkVersion: function(){
        let versionRegex = /^[0-9]+(\.[0-9]+)*$/;
        if(this.version == '' || versionRegex.test(this.version)){
          this.validVersion = true;
        } else {
          this.validVersion = false;
        }
      },

      validate: function(){
        if(this.projectName === '') {
          this.formErrorMsg = "Missing required fields";
          return false;
        }
        if(!this.validVersion){
          this.formErrorMsg = "The version entered is not valid";
          return false;
        }
        return true;
      },

      //===========================================================================================
      //	Method Name	:	submitChanges
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Submits changes to a project
      //===========================================================================================
      submitChanges: async function(){
        let token = this.$store.getters.getToken;

        if(this.validate() === false){
          this.missingRequired = true;
          return;
        }
        this.missingRequired = false;
        try {
          //Update project data

          this.projectName = sanitizeInput(this.projectName, this.$sanitize);
          this.projectManger = sanitizeInput(this.projectManager, this.$sanitize);
          this.version = sanitizeInput(this.version, this.$sanitize);
          
          let data = {
            data:{
              ProjectName: this.projectName,
              ProjectManager: this.projectManager,
              version: this.version,
              ccb_users: this.ccbMembers.map(user => user.id)
            }
          }              
          if(this.addingProject){
            await DatabaseLib.postRequest('strapiDatabase','projects',token,data);
          } else {
            await DatabaseLib.putRequest('strapiDatabase','projects',token,this.projectId,data);

            // update submitted QPRs foundIn
            if(this.projectName !== this.oldProjectName){
              const payload = {
                projectName: this.oldProjectName,
                data: {foundIn: this.projectName}
              };
              await DatabaseLib.postRequest('strapiDatabase', 'submitted-qpr/bulk-update', token,payload);
            }

          }

          if(this.addingProject){this.p1_success = true} else {this.p2_success = true;}

          this.previewing = false;
          this.populateProjectData();
        } catch(error) {
          this.p1_fail = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }
        this.resetData();
        window.scroll({top: 0, behavior: 'smooth'});
      },

      //===========================================================================================
      //	Method Name	:	populatePMs
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Gets all project managers for the dropdown to select a PM
      //===========================================================================================
      populatePMs: async function(){
        let token = this.$store.getters.getToken;	
        let query = "filters[blocked][$eq][0]="+false+"&populate[1]=groups&populate[2]=role";
        let response = '';      
        try {
            response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
        } catch(error) {
            window.scroll({top: 0, behavior: 'smooth'});
            return;
        }
        let pm = [];
        for(let c = 0; c < response.data.length; c = c + 1){
          if(response.data[c].role.name != "Administrator"){
            for(let i = 0; i < response.data[c].groups.length; i = i + 1) {
              if(response.data[c].groups[i].name == "Project Manager"){
                pm.push(response.data[c]);
              }
            }
          }
        }

        this.pmOptions = [];
        pm.forEach(manager => {
            let obj = {};
            obj["text"] = manager.firstName + ' ' + manager.lastName;
            obj["value"] = manager.username;
            if (this.projectManager === obj.value)
            {
                obj["selected"] = true;
            }
            this.pmOptions.push(obj);
        });
      },

      populateCCBUsers: async function(){
        let token = this.$store.getters.getToken;	
        let query = "filters[blocked][$eq][0]="+false+"&populate[1]=groups&populate[2]=role";
        let response = '';      
        try {
            response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
        } catch(error) {
            window.scroll({top: 0, behavior: 'smooth'});
            return;
        }
        for(let c = 0; c < response.data.length; c = c + 1){
          if(response.data[c].role.name != "Administrator"){
            for(let i = 0; i < response.data[c].groups.length; i = i + 1) {
              if(response.data[c].groups[i].name == "CCB"){
                this.allCCBUsers.push(response.data[c]);
              }
            }
          }
        }
      },

      populateCCBOptions: function(){
        this.viewCCBTable = true;
        const ccbIds = new Set(this.ccbMembers.map(u => u.id));
        const usersInCcb = [];
        const usersNotInCcb = [];
        this.allCCBUsers.forEach(user => {
          const clonedUser = { ...user };

          if (ccbIds.has(user.id)) {
            usersInCcb.push(clonedUser);
          } else {
            usersNotInCcb.push(clonedUser);
          }
        });
        this.userOptionsInCCB = {
          columns: [...this.userOptionsInCCB.columns],
          rows: [...usersInCcb]
        };
        this.userOptionsForCCB = {
          columns: [...this.userOptionsForCCB.columns],
          rows: [...usersNotInCcb]
        };
        this.addedCCBUsers = [];
        this.removedCCBUsers = [];
        this.inCcbKey++;
        this.forCcbKey++;
      },

      //===========================================================================================
      //	Method Name	:	setPM
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Sets the project manager
      //===========================================================================================
      setPM: function(value){
        this.oldProjectManager = this.projectManager;
        this.projectManager = value;
      },

      // Handle adding and removing CCB users
      setCCB: function(){
        const idsToRemove = new Set(this.addedCCBUsers.map(user => user.id));
        this.ccbMembers = this.ccbMembers.filter(user => !idsToRemove.has(user.id));
        this.populateCCBOptions();
      },
      removeCCB: function(){
        const formatted = this.removedCCBUsers.map(user => ({
          id: user.id,
          attributes: { ...user }
        }));
        this.ccbMembers.push(...formatted);
        this.populateCCBOptions();
      },


      //===========================================================================================
      //	Method Name	:	createProject
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Event handler for creating a new project
      //===========================================================================================
      createProject: async function(){
        this.resetData();
        this.populatePMs();
        this.previewing = true;
        this.$nextTick(function() {
          this.$refs.preview.scrollIntoView({behavior: 'smooth'})
        })
        this.addingProject = true;  
      },

       // View the work that has been done for this build
      viewAllWork: async function(data) {
        this.$router.push({
          name: 'ViewEditBuild',
          query: {
            id: data.buildId,
            project: data.id
          }
        })
      },
      
      //===========================================================================================
      //	Method Name	:	checkGroups
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Determine what groups the user belongs to
      //===========================================================================================
      checkGroups: function(){
        if (this.$store.getters.getRole == "Administrator"){
          this.isAdmin = true;
        }
        if (this.$store.getters.getGroups.includes("Project Manager")){
          this.isPM = true;
        }
        if (this.$store.getters.getGroups.includes("CM")){
          this.isCM = true;
        }
        if (this.$store.getters.getGroups.includes("Developer")){
          this.isDev = true;
        }
        if(JSON.parse(this.$store.getters.getCCBGroups).length > 0){
          this.isCCB = true;
        }
      },
    },
  
    mounted() {
      this.checkGroups();
      this.populateCCBUsers();
      this.populateProjectData();
    }
  }
  </script>
  